import React from 'react';
import { connect } from 'react-redux';

import classes from './Cell.css';
import Icon from '../../components/UI/Icon/Icon';
import moreImg from '../../assets/images/more-icon.png';
import Dropdown from '../../components/UI/Dropdown/Dropdown';
import Button from '../../components/UI/Button/Button';
import Aux from '../../hoc/Auxiliary/Auxiliary';
import arrowImg from '../../assets/images/arrow-right-icon.png';
import * as actionTypes from '../../store/actions';

const cell = (props) => {

  let cellClass = [classes.Cell];
  switch (props.cellClass) {
    case 'Heading':
      cellClass.push(classes.CellHeading);
      break;
    case 'Cell':
      cellClass.push(classes.CellNormal);
      break;
    default:
      break;
  }

  if (props.desktopOnly) {
    cellClass.push(classes.CellDesktopOnly);
  }

  if (props.active === false) {
    cellClass.push(classes.CellDisabled);
  }

  if (props.from === props.to && props.cellClass !== 'Heading') {
    cellClass.push(classes.CellIdentical);
  }

  const style = {
    gridArea: props.gridArea
  };

  let cellLabel = null;
  if (props.from && props.to) {

    let dropdown = null;
    if (props.role === 'ROLE_ADMIN' || props.role === 'ROLE_DISPATCHER') {
      dropdown = (
        <Dropdown
          dropdown=""
          dropIcon={moreImg}
          dropIconClass={classes.MoreIcon}
          className={classes.DropdownClass}>
          <Button
            btnType='Danger'
            clicked={() => props.onShowNewTrip(true, props.origin, props.destination)}
            extraClass={classes.ButtonDropdown}>+ РЕЙС</Button>
          <Button
            btnType='Danger'
            clicked={() => props.onShowNewRequest(true, props.origin, props.destination)}
            extraClass={classes.ButtonDropdown}>+ ЗАЯВКА</Button>
        </Dropdown>
      );
    } else if (props.role === 'ROLE_MANAGER' || props.role === "ROLE_RULER") {
      dropdown = (
        <Dropdown
          dropdown=""
          dropIcon={moreImg}
          dropIconClass={classes.MoreIcon}
          className={classes.DropdownClass}>
          <Button
            btnType='Danger'
            clicked={() => props.onShowNewRequest(true, props.origin, props.destination)}
            extraClass={classes.ButtonDropdown}>+ ЗАЯВКА</Button>
        </Dropdown>
      );
    }

    cellLabel = (
      <Aux>
        <div className={classes.CellLabel}>
          {props.from}
          <Icon iconClass={classes.ArrowIcon} iconSource={arrowImg} iconAlt='' />
          {props.to}
          { dropdown }
        </div>
      </Aux>
    );
  }

  return (
    <div
      className={cellClass.join(' ')}
      style={style}>
      {cellLabel}
      {props.children}
    </div>
  );
};

const mapStateToProps = state => {
  return {
    showNewTrip: state.showNewTrip,
    showNewRequest: state.showNewRequest,
    role: state.role
  };
}

const mapDispatchToProps = dispatch => {
  return {
    onShowNewTrip: (showNewTrip, origin, destination) => dispatch({ type: actionTypes.SHOW_NEW_TRIP,
                                                                    showNewTrip: showNewTrip,
                                                                    origin: origin,
                                                                    destination: destination }),
    onShowNewRequest: (showNewRequest, origin, destination) => dispatch({ type: actionTypes.SHOW_NEW_REQUEST,
                                                                          showNewRequest: showNewRequest,
                                                                          origin: origin,
                                                                          destination: destination })
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(cell);



// WEBPACK FOOTER //
// ./src/hoc/Cell/Cell.js